import React, { useState } from 'react';
import { Paper, Typography, List, ListItem, ListItemText, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';

const initialVersions = [
  { id: 1, version: 'v1.2.3', date: '2023-05-15', description: 'Latest stable release' },
  { id: 2, version: 'v1.2.2', date: '2023-05-01', description: 'Bug fixes and performance improvements' },
  { id: 3, version: 'v1.2.1', date: '2023-04-15', description: 'New features added' },
];

const VersionControlPanel = () => {
  const [versions, setVersions] = useState(initialVersions);
  const [openDialog, setOpenDialog] = useState(false);
  const [newVersion, setNewVersion] = useState({ version: '', description: '' });

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewVersion({ version: '', description: '' });
  };

  const handleInputChange = (event) => {
    setNewVersion({
      ...newVersion,
      [event.target.name]: event.target.value,
    });
  };

  const handleAddVersion = () => {
    const newVersionEntry = {
      id: versions.length + 1,
      version: newVersion.version,
      date: new Date().toISOString().split('T')[0],
      description: newVersion.description,
    };
    setVersions([newVersionEntry, ...versions]);
    handleCloseDialog();
  };

  const handleRollback = (version) => {
    // Here you would typically trigger the rollback process
    console.log(`Rolling back to version ${version}`);
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Version Control Panel</Typography>
      <Button variant="contained" color="primary" onClick={handleOpenDialog} sx={{ mb: 2 }}>
        Add New Version
      </Button>
      <List>
        {versions.map((v) => (
          <ListItem key={v.id} divider>
            <ListItemText
              primary={`${v.version} - ${v.date}`}
              secondary={v.description}
            />
            <Button variant="outlined" color="secondary" onClick={() => handleRollback(v.version)}>
              Rollback
            </Button>
          </ListItem>
        ))}
      </List>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Add New Version</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="version"
            label="Version Number"
            type="text"
            fullWidth
            value={newVersion.version}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            name="description"
            label="Description"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={newVersion.description}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddVersion} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default VersionControlPanel;
